import { apiAxios } from '@/lib/apiAxios';
export const fetchInternalCampaigns = async () => apiAxios.get('/internal/campaigns').then((r) => r.data);
